import * as React from 'react';
import { TNavigationPanel } from './NavigationPanel.types';
import { ADMIN_PANEL_CONFIG } from 'screens/AdminPanel/config';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from 'components';
import { ExpandMore } from '@mui/icons-material';
import './NavigationPanel.styles.scss';
import { hasSelectedChild } from './utils';

export const NavigationPanel: TNavigationPanel = ({
  selectedPanelItemId,
  setSelectedPanelItem,
}) => {
  const STOCK_ITEM_ID = 'stock-items';
  const stockConfig = ADMIN_PANEL_CONFIG.find((item) => item.id === 'stock');
  const accordionConfigs = ADMIN_PANEL_CONFIG.filter(
    (item) => item.id !== 'stock'
  );

  return (
    <>
      {stockConfig && (
        <Button
          variant={
            selectedPanelItemId === STOCK_ITEM_ID ? 'contained' : 'outlined'
          }
          onClick={() => setSelectedPanelItem(STOCK_ITEM_ID)}
          fullWidth
        >
          {stockConfig.displayName}
        </Button>
      )}

      {accordionConfigs.map((adminPanelConfigItem) => (
        <div key={adminPanelConfigItem.id}>
          <Accordion
            slotProps={{ heading: { component: 'h4' } }}
            key={adminPanelConfigItem.id}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls="panel1-content"
              id="panel1-header"
              disableRipple={hasSelectedChild(
                selectedPanelItemId,
                adminPanelConfigItem.children
              )}
            >
              <p className="body2">{adminPanelConfigItem.displayName}</p>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                {adminPanelConfigItem.children.map((panelConfigChild) => (
                  <div
                    key={panelConfigChild.id}
                    className={`navigation-panel__navigation-child ${
                      selectedPanelItemId === panelConfigChild.id
                        ? 'navigation-panel__navigation-child--selected'
                        : ''
                    }`}
                    onClick={() => setSelectedPanelItem(panelConfigChild.id)}
                  >
                    {panelConfigChild.displayName}
                  </div>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      ))}
    </>
  );
};
